<template>
    <section ref="team" class="team">
        <transition-group class="team__members-photo-container-desktop" name="teamMember-fade" appear>
                <img
                    v-for="(teamMember, index) in teamMembers"
                    v-if="index === teamMemberIndex"
                    :key="index"
                    :src="teamMember.image.sizes.xxxlarge"
                    :srcset="teamMember.image.sizes.medium + ' 768w, ' + teamMember.image.sizes.large + ' 1024w, ' + teamMember.image.sizes.xlarge + ' 1280w, ' + teamMember.image.sizes.xxlarge + ' 1920w,' + teamMember.image.sizes.xxxlarge + ' 3000w'"
                    sizes="(min-width: 1024px) 330vh, (min-width: 425px) 1000px, 533px"
                    :alt="teamMember.image.alt === '' ? 'Photo of ' + teamMember.post_title : teamMember.image.alt"
                    class="team__members-photo"
                >
            </transition-group>
        <div
            class="team__inner wow fadeInUp"
            data-wow-delay="0.5s"
        >
            <header class="team__heading-content">
                <slot name="team-heading-mobile"/>
                <select v-model="activeTeamMember" class="select-dark team__members">
                    <option disabled aria-label="select" v-text="optionText"/>
                    <option
                        v-for="teamMember in teamMembers"
                        :key="teamMember.ID"
                        v-text="teamMember.post_title"
                    />
                </select>
            </header>
            <transition-group class="team__members-photo-container" tag="div" name="teamMember-fade" appear>
                <img
                    v-for="(teamMember, index) in teamMembers"
                    v-if="index === teamMemberIndex"
                    :key="index"
                    :src="teamMember.image.sizes.large"
                    :srcset="teamMember.image.sizes.medium + ' 768w, ' + teamMember.image.sizes.large + ' 1024w, ' + teamMember.image.sizes.xlarge + ' 1280w, ' + teamMember.image.sizes.xxlarge + ' 1920w'"
                    sizes="(min-width: 1024px) 330vh, (min-width: 425px) 1000px, 533px"
                    :alt="teamMember.image.alt === '' ? 'Photo of ' + teamMember.post_title : teamMember.image.alt"
                    class="team__members-photo"
                >
            </transition-group>
            <div
                data-wow-delay="0.5s"
                :class="showItem ? 'fade-primary' : null"
                class="team__member-container_left"
            >
                <slot name="team-heading-desktop"/>
                <ul class="team__member-list">
                    <li
                        v-for="(teamMember, index) in teamMembers"
                        :key="index"
                        @click="activateTeamMember(teamMember)"
                        class="team__member-item"
                    >
                        <button class="team__member-item-btn" v-text="teamMember.post_title"/>
                    </li>
                </ul>
            </div>
            <div
                v-for="teamMember in filteredTeamMember"
                :key="teamMember.ID"
                class="team__member-container_right"
            >
                <article
                    data-wow-delay="0.5s"
                    :class="showItem ? 'fade-primary' : null"
                    class="team__member-description-container"
                >
                    <h3 class="team__member-name" v-text="teamMember.post_title"/>
                    <slot name="svg"/>
                    <p
                        v-text="teamMember.copy"
                        class="team__member-copy team__member-copy--mobile"
                    />
                    <div class="team__member-nav-container">
                        <button
                            @click="decrementTeamMember()"
                            :class="teamMemberIndex === 0 ? 'team__member-previous-button--disabled' : null"
                            class="team__member-previous-button"
                        >
                            <slot name="carrot-svg"/>
                            <p class="team__member-nav-copy" v-text="'Previous'"/>
                        </button>
                        <button
                            @click="incrementTeamMember()"
                            :class="teamMemberIndex === teamMembers.length -1 ? 'team__member-next-button--disabled' : null"
                            class="team__member-next-button"
                        >
                            <p class="team__member-nav-copy" v-text="'Next'"/>
                            <slot name="carrot-svg-rotated"/>
                        </button>
                    </div>
                    <div
                        is="base-reveal"
                        v-if="windowWidth >= 1024"
                        :base-copy="teamMember.copy"
                    />
                </article>
            </div>
        </div>
    </section>
</template>

<script>
import BaseReveal from '@/components/BaseReveal';


export default {
    name: 'team',
    components: {
        BaseReveal,
    },
    props: {
        teamMembers: {
            type: Array,
            required: true,
        },
        optionText: {
            type: String,
            required: true,
        },
        buttonTextPrimary: {
            type: String,
            required: true,
        },
        buttonTextSecondary: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            windowWidth: 0,
            showItem: true,
            teamMemberIndex: 0,
            showTeamMember: false,
            activeTeamMember: undefined,
        };
    },
    /* eslint-disable */
    computed: {
        filteredTeamMember() {
            const self = this;
            return this.teamMembers.filter((teamMember) => {
                const foundTeamMember = teamMember
                    .post_title
                    .toLowerCase()
                    .indexOf(self.activeTeamMember.toLowerCase())
                    > -1;

                if (foundTeamMember) {
                    this.teamMemberIndex = this.teamMembers.indexOf(teamMember);
                }

                return foundTeamMember;
            });
        },
    },
    methods: {
        getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        },
        windowScroll(teamMembers) {
            window.scrollTo(0, 170);
            return teamMembers;
        },
        activateTeamMember(currentTeammember) {
            this.showItem = false;
            this.activeTeamMember = currentTeammember.post_title;
        },
        incrementTeamMember() {
            this.activeTeamMember = this.teamMemberIndex < this.teamMembers.length -1
                ? this.windowScroll(this.teamMembers[this.teamMemberIndex + 1].post_title)
                : this.teamMembers[this.teamMembers.length - 1].post_title
        },
        decrementTeamMember() {
            this.activeTeamMember = this.teamMemberIndex > 0
                ? this.windowScroll(this.teamMembers[this.teamMemberIndex - 1].post_title)
                : this.teamMembers[0].post_title;
        },
    },
    created() {
        this.activeTeamMember = this.teamMembers[0].post_title;
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.getWindowWidth);
            this.getWindowWidth();
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    },
};
</script>



// WEBPACK FOOTER //
// Team.vue?49374726